const checkSymbols = (value, dataSymbols) => {
    for (let i = 0; i <= dataSymbols.length; i++) {
        const item = dataSymbols[i];
        const includeSymbols = Array.from(item).every(itemSymbol => value.includes(itemSymbol));
        if (includeSymbols) {
            return item
        }
    }
}

const fileNamesWith2Symbols = ['tw', 'tc', 'tm', 'cw', 'cm', 'wm'];
const fileNamesWith3Symbols = ['tcw', 'tcm', 'twm', 'cwm'];
const fileNamesWith4Symbols = ['tcwm'];

export const orderStationSymbols = function (station) {
    if (station.length === 1) return station;
    if (station.length === 2) return checkSymbols(station, fileNamesWith2Symbols)
    if (station.length === 3) return checkSymbols(station, fileNamesWith3Symbols)
    return checkSymbols(station, fileNamesWith4Symbols)
};
